import React from 'react';
import "./assets/styles/index.scss";
import App from './App';
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {RecoilRoot} from "recoil";
import ReactDOM from 'react-dom/client';
import axios from "axios";
import {AXIOS_DEFAULTS_TIMEOUT} from "./core/variables";

axios.defaults.withCredentials = true;
axios.defaults.timeout = Number(AXIOS_DEFAULTS_TIMEOUT);

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            useErrorBoundary: true,
        }
    }
})

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

root.render(
    <QueryClientProvider client={queryClient}>
        <RecoilRoot>
            <App />
        </RecoilRoot>
    </QueryClientProvider>
);
